import AnimatedLine, { AnimatedLineConfig } from "./AnimatedLine";

const config: AnimatedLineConfig = {
    viewBox: "0 0 724 521",
    path: "M0.480469 520.129C114.712 129.093 671.241 194.87 723.48 0.128906",
    dots: [
        { cx: 121.48, cy: 328.211, r: 12, delay: 0.6 },
        { cx: 273.48, cy: 231.129, r: 12, delay: 1.2 },
        { cx: 695.48, cy: 49.484, r: 12, delay: 1.8 },
    ],
    gradient: { x: 361.981, y1: 0.128906, y2: 520.129 },
};

const Line2 = ({ className }: { className?: string }) => (
    <AnimatedLine {...config} className={className} />
);

export default Line2;
